import styles from './idea-channel-manage.module.less';
import { PlusOutlined, RightOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Channel, GET_CHANNELS } from '@frontend/data-access';
import { IdeaChannelCreate } from '@frontend/feature-idea-channel';
import { Button, Modal, Spin } from 'antd';
import { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

/* eslint-disable-next-line */
export interface IdeaChannelManageProps {
  onFinish: () => void;
  onCancel: () => void;
}

export function IdeaChannelManage({
  onCancel,
  onFinish,
}: IdeaChannelManageProps) {
  const { t } = useTranslation('common');
  const [currentId, setCurrentId] = useState<string>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, loading } = useQuery<{
    channels: Channel[];
  }>(GET_CHANNELS);

  const handleClose = () => {
    setIsModalOpen(false);
    setCurrentId(undefined);
  };

  const handleModal = (id?: string) => {
    id && setCurrentId(id);
    setIsModalOpen(true);
  };

  if (loading) {
    return (
      <div className="p-10 text-center">
        <Spin />
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      <div className="mt-6 space-y-6">
        <div className="space-y-2 max-h-[80vh] overflow-auto">
          {data?.channels.map((item) => (
            <div
              key={item.id}
              onClick={() => handleModal(item.id)}
              className="p-3 border rounded-lg border-gray-400 flex justify-between items-center cursor-pointer"
            >
              <div className="text-gray-900 text-sm font-medium">
                {item.title}
              </div>
              <div>
                <RightOutlined />
              </div>
            </div>
          ))}
        </div>
        <Button
          shape="round"
          ghost
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => handleModal()}
        >
          {t('add_channel')}
        </Button>
      </div>
      <Modal
        title={currentId ? t('edit_channel') : t('add_channel')}
        open={isModalOpen}
        onCancel={handleClose}
        width={1024}
        footer={null}
      >
        <IdeaChannelCreate
          id={currentId}
          onFinish={handleClose}
          onCancel={handleClose}
        />
      </Modal>
    </div>
  );
}

export default IdeaChannelManage;
